module.exports = __webpack_public_path__ + "static/media/frost-alternate-flipped-rotated-adjusted.5d149705.svg";